import { render, staticRenderFns } from "./ProductFilesStatus.vue?vue&type=template&id=f8e0a53e&scoped=true&"
import script from "./ProductFilesStatus.vue?vue&type=script&lang=js&"
export * from "./ProductFilesStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilesStatus.vue?vue&type=style&index=0&id=f8e0a53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e0a53e",
  null
  
)

export default component.exports